<template>
  <div
    v-if="show"
    class="badiu-tiptap-modal"
    tabindex="-1"
    @mousedown.self="onCancel"
  >
    <div class="badiu-tiptap-modal-dialog">
      <div class="badiu-tiptap-modal-content">

        <div class="badiu-tiptap-modal-header">
          <h6 class="badiu-tiptap-modal-title">
            <i class="fas fa-link"></i>Insert / edit link
          </h6>
          <button
            type="button"
            class="badiu-tiptap-modal-close"
            aria-label="Close"
            @click="onCancel"
          >&times;</button>
        </div>

        <div class="badiu-tiptap-modal-body">

          <div class="badiu-tiptap-form-group">
            <label class="badiu-tiptap-form-label">URL</label>
            <div class="badiu-tiptap-input-with-action">
              <input
                v-model="form.href"
                type="text"
                class="badiu-tiptap-input"
                placeholder="https://..."
              />
              <badiu-tiptap-file-upload
                accept="*/*"
                filetype="file"
                title="Upload file and use URL"
                icon="fa-paperclip"
                :config="config"
                @uploaded="onUploaded"
                @error="onUploadError"
              />
            </div>
          </div>

          <div class="badiu-tiptap-form-group">
            <label class="badiu-tiptap-form-label">Display text</label>
            <input
              v-model="form.text"
              type="text"
              class="badiu-tiptap-input"
              placeholder="Link text"
            />
          </div>

          <div class="badiu-tiptap-form-group">
            <label class="badiu-tiptap-form-label">Title (tooltip)</label>
            <input
              v-model="form.title"
              type="text"
              class="badiu-tiptap-input"
              placeholder="Shown on hover"
            />
          </div>

          <div class="badiu-tiptap-form-group">
            <label class="badiu-tiptap-form-label">Open in</label>
            <select v-model="form.target" class="badiu-tiptap-select">
              <option value="">Same window (default)</option>
              <option value="_blank">New window (_blank)</option>
            </select>
          </div>

        </div>

        <div class="badiu-tiptap-modal-footer">
          <button
            v-if="hasExistingLink"
            type="button"
            class="badiu-tiptap-btn badiu-tiptap-btn-outline-danger"
            @click="onRemove"
          >
            <i class="fas fa-unlink"></i> Remove link
          </button>

          <button
            type="button"
            class="badiu-tiptap-btn badiu-tiptap-btn-secondary"
            @click="onCancel"
          >
            Cancel
          </button>

          <button
            type="button"
            class="badiu-tiptap-btn badiu-tiptap-btn-primary"
            :disabled="!form.href"
            @click="onSave"
          >
            Save
          </button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
/**
 * BadiuTiptapLink
 *
 * Isolated modal component for inserting and editing links — TinyMCE-style:
 *  - URL (with optional file upload)
 *  - Display text
 *  - Title (tooltip)
 *  - Target (same window / _blank)
 *  - Remove existing link
 */
import { reactive, computed, watch } from 'vue'
import BadiuTiptapFileUpload from './BadiuTiptapFileUpload.vue'

export default {
  name: "BadiuTiptapLink",

  components: {
    BadiuTiptapFileUpload
  },

  props: {
    show: {
      type: Boolean,
      default: false
    },

    initial: {
      type: Object,
      default: () => ({})
    },

    /** Forwarded to BadiuTiptapFileUpload (ver BadiuTiptapEditor para doc das chaves). */
    config: {
      type: Object,
      default: () => ({})
    }
  },

  emits: ["save", "remove", "cancel", "uploaded", "error"],

  setup(props, { emit }) {
    const form = reactive({
      href:   "",
      text:   "",
      title:  "",
      target: ""
    });

    const hasExistingLink = computed(() => !!props.initial.href);

    watch(
      () => props.show,
      (visible) => {
        if (visible) {
          form.href   = props.initial.href   || "";
          form.text   = props.initial.text   || "";
          form.title  = props.initial.title  || "";
          form.target = props.initial.target || "";
        }
      },
      { immediate: true }
    );

    function onSave() {
      if (!form.href) return;

      emit("save", {
        href:   form.href,
        text:   form.text || form.href,
        title:  form.title  || null,
        target: form.target || null
      });
    }

    function onRemove() {
      emit("remove");
    }

    function onCancel() {
      emit("cancel");
    }

    function onUploaded(payload) {
      form.href = payload.url;

      if (!form.text && payload.name) {
        form.text = payload.name;
      }

      emit("uploaded", payload);
    }

    function onUploadError(payload) {
      emit("error", payload);
    }

    return {
      form,
      hasExistingLink,
      onSave,
      onRemove,
      onCancel,
      onUploaded,
      onUploadError
    };
  }
};
</script>
